import React from 'react';
import { createUseStyles } from 'react-jss';

// style =====================================

const useStyles = createUseStyles({
  body: {
    padding: 14,
    fontSize: 14,
    color: '#6D819C',
  },
});

// component =================================

type Props = {
  children: React.ReactNode;
};

const SegmentBody = (props: Props) => {
  const { children } = props;
  const classes = useStyles();

  return <div className={classes.body}>{children}</div>;
};

export default SegmentBody;
